import { postAction } from './client';
import { currentSession, signOut } from '../auth/session';
import { bustCache } from '../lib/swr';

type Row = Record<string, unknown>;

async function call<T>(action: string, payload: Record<string, unknown> = {}): Promise<T> {
  const ses = currentSession();
  if (!ses) throw new Error('Not signed in.');
  const res = await postAction<T & { ok: boolean; error?: string; message?: string }>(action, { ...payload, token: ses.token });
  if (!res.ok) {
    if (res.error === 'AUTH_REQUIRED' || res.error === 'AUTH_INVALID') signOut();
    throw new Error(res.message || res.error || 'Request failed');
  }
  if (/^(claimComplaint|forwardComplaint|resolveComplaint|adminAddComplaint|adminDeleteComplaint|adminSaveMaterial|adminDeleteMaterial)/.test(action)) bustCache();
  return res;
}

export interface LiteOperator { operatorId: string; name: string; role: string }
export interface MaterialRow { name: string; active: boolean }

export interface ResolveInput {
  note?: string;
  materialUsed?: string; materialQty?: number | '';
  condemnedItem?: string; condemnedQty?: number | '';
}

/** Any signed-in user — the shared complaints workflow (operators + admins see the same board). */
export const complaintsApi = {
  list: (status?: string) => call<{ ok: true; rows: Row[] }>('listComplaints', status ? { status } : {}),
  timeline: (complaintId: string) => call<{ ok: true; rows: Row[] }>('complaintTimeline', { complaintId }),
  operators: () => call<{ ok: true; rows: LiteOperator[] }>('listOperatorsLite'),
  materials: () => call<{ ok: true; rows: MaterialRow[] }>('listMaterials'),
  claim: (complaintId: string) => call<{ ok: true }>('claimComplaint', { complaintId }),
  forward: (complaintId: string, toOperatorId: string, note?: string) =>
    call<{ ok: true }>('forwardComplaint', { complaintId, toOperatorId, note }),
  resolve: (complaintId: string, input: ResolveInput) => call<{ ok: true }>('resolveComplaint', { complaintId, ...input }),
  adminAdd: (complaint: Row) => call<{ ok: true; complaintId: string }>('adminAddComplaint', { complaint }),
  adminDelete: (complaintId: string) => call<{ ok: true }>('adminDeleteComplaint', { complaintId }),
  adminSaveImportSecret: (importSecret: string) => call<{ ok: true }>('adminSaveComplaintImportSecret', { importSecret }),
  adminSaveMaterial: (name: string, active = true) => call<{ ok: true }>('adminSaveMaterial', { name, active }),
  adminDeleteMaterial: (name: string) => call<{ ok: true }>('adminDeleteMaterial', { name }),
};
